import { ADJUSTER_REPORT_BASE_PATH } from '@/config/baseModulesLink';

export const INCIDENT_DETAIL_BASE_PATH = 'incident-details';
export const INCIDENT_DETAIL_PROPERTY_BASE_PATH = 'property';
export const INCIDENT_DETAIL_BODY_BASE_PATH = 'body';
export const INCIDENT_DETAIL_INITIAL_VISIT_BASE_PATH = 'initial-visit';
export const INCIDENT_SHOW_DETAIL_PROPERTY_BASE_PATH = 'show-property';
export const INCIDENT_SHOW_DETAIL_BODY_BASE_PATH = 'show-body';
export const INCIDENT_SHOW_DETAIL_INITIAL_VISIT_BASE_PATH =
  'show-initial-visit';

export const IncidentDetailsLinks = {
  INCIDENT_DETAIL_BASE_PATH: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INCIDENT_DETAIL_BASE_PATH}`,
  INCIDENT_DETAIL_PROPERTY_BASE_PATH: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INCIDENT_DETAIL_BASE_PATH}/${INCIDENT_DETAIL_PROPERTY_BASE_PATH}`,
  INCIDENT_DETAIL_BODY_BASE_PATH: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INCIDENT_DETAIL_BASE_PATH}/${INCIDENT_DETAIL_BODY_BASE_PATH}`,
  INCIDENT_DETAIL_INITIAL_VISIT_BASE_PATH: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INCIDENT_DETAIL_BASE_PATH}/${INCIDENT_DETAIL_INITIAL_VISIT_BASE_PATH}`,
  INCIDENT_SHOW_DETAIL_PROPERTY: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INCIDENT_DETAIL_BASE_PATH}/${INCIDENT_SHOW_DETAIL_PROPERTY_BASE_PATH}`,
  INCIDENT_SHOW_DETAIL_BODY_BASE_PATH: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INCIDENT_DETAIL_BASE_PATH}/${INCIDENT_SHOW_DETAIL_BODY_BASE_PATH}`,
  INCIDENT_SHOW_DETAIL_INITIAL_VISIT_BASE_PATH: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INCIDENT_DETAIL_BASE_PATH}/${INCIDENT_SHOW_DETAIL_INITIAL_VISIT_BASE_PATH}`,
};
